module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart-container"
  }, [_c('apexchart', {
    attrs: {
      "type": "line",
      "height": _vm.chartHeight,
      "options": _vm.apexOptions,
      "series": _vm.apexSeries
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2767c7eb","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/ClientTeusLineChart.vue
// module id = 2474
// module chunks = 0